import { request } from "#/utils/request";

export type TBuscarPdfPropostaEApolice = {
  tipoPdf: string;
  numeroProposta: string;
};

export const ENDPOINT_PDF = "/pdf";

export async function buscaPdfPropostaEApolice({
  tipoPdf,
  numeroProposta,
}: TBuscarPdfPropostaEApolice) {
  const { data } = await request.get<{ arquivoBase64: string }>(ENDPOINT_PDF, {
    params: {
      tipoPDF: tipoPdf,
      proposta: numeroProposta,
    },
  });

  return data;
}
